/**
 * CarouselPosting - 캐러셀 컴포넌트
 */
(function(global) {
    'use strict';

    var CONSTANTS = {
        THRESHOLD: 100,           // 슬라이드가 인식되는 최소 드래그 거리
        OUTPOS: 1000,           // 슬라이드가 화면 밖으로 나가는 위치 (모바일)
        PC_OUT: 500,            // 슬라이드가 화면 밖으로 나가는 위치 (PC)
        TRANSITION_DELAY: 100,  // 애니메이션 적용 딜레이
        BLOCK_DELAY: 160,       // 버튼/제스처 입력 블록 시간
        ARROW_DELAY: 200,       // 화살표 애니메이션 지연 시간
        ARROW_SETTLE: 300,      // 화살표 위치 안정화 시간
        MIN_GESTURE: 10         // 슬라이드 이동을 위한 최소값
    };
    
    /**
     * SLIDE_CLASSES: 슬라이드의 위치 상태에 따라 적용되는 CSS 클래스 목록
     *  - slidePos0~3: 0~3번째 위치
     *  - slideOut: 화면 밖으로 나간 상태
     *  - slideTransitionNone: 트랜지션 미적용 상태
     */
    var SLIDE_CLASSES = ['slidePos0', 'slidePos1', 'slidePos2', 'slidePos3', 'slideOut', 'slideTransitionNone'];

    // ============================================
    // 공통 함수
    // ============================================
    function mod(n, m) {
        return ((n % m) + m) % m;
    }

    function getOption(value, defaultValue) {
        return typeof value !== 'undefined' ? value : defaultValue;
    }

    function removeClasses(el, classes) {
        if (!el) return;
        var i;
        for (i = 0; i < classes.length; i++) {
            el.classList.remove(classes[i]);
        }
    }

    function addClasses(el, classes) {
        if (!el) return;
        var i;
        for (i = 0; i < classes.length; i++) {
            el.classList.add(classes[i]);
        }
    }

    function safeTimeout(timerRef, callback, delay) {
        if (timerRef.value) clearTimeout(timerRef.value);
        timerRef.value = setTimeout(callback, delay);
        return timerRef;
    }

    /* LoopedPlaylist - 순환 목록 관리 */
    function createLoopedPlaylist(arr, length) {
        var len = arr.length;
        var index = 0;

        function getSlides(baseIndex) {
            var result = [arr[mod(baseIndex, len)]];
            if (length >= 2) result.push(arr[mod(baseIndex + 1, len)]);
            if (length >= 3) result.push(arr[mod(baseIndex + 2, len)]);
            return result;
        }

        return {
            next: function(step) {
                step = getOption(step, 1);
                index = mod(index + step, len);
                return getSlides(index);
            },
            prev: function(step) {
                step = getOption(step, 1);
                index = mod(index - step, len);
                return getSlides(index);
            },
            current: function() {
                return getSlides(index);
            },
            reset: function() {
                index = 0;
            },
            setIndex: function(newIndex) {
                index = mod(newIndex, len);
            },
            getIndex: function() {
                return index;
            },
            peekPrev: function(step) {
                step = getOption(step, 1);
                return getSlides(mod(index - step, len));
            }
        };
    }

    // ============================================
    // 리빙 트렌드 메인 컴포넌트
    // ============================================
    function CarouselPosting(options) {
        options = options || {};

        var config = {
            children: options.children || [], // Carousel에 포함될 슬라이드 요소 리스트
            ariaLabel: getOption(options.ariaLabel, '이미지 슬라이드쇼'), // 슬라이드 영역 접근성 라벨 설정
            isMobile: getOption(options.isMobile, true), // 모바일 여부
            isDisabled: getOption(options.isDisabled, false), // Carousel 비활성화
            onChange: getOption(options.changeCarousel, null) // 슬라이드 변경 시 호출되는 콜백 함수
        };

        var state = {
            startX: 0,              // 드래그 시작 X 좌표
            startY: 0,              // 드래그 시작 Y 좌표
            dragX: 0,               // 현재 드래그중인 X 이동값
            dragXVal: 0,            // 마지막 드래그 X 위치값 (거리판단)
            activeEl: null,         // 현재 활성화된 슬라이드 엘리먼트
            prevSlide: null,        // 이전 슬라이드 엘리먼트
            isDragging: false,      // 드래그 진행중 여부
            isTransition: false,    // 트랜지션(애니메이션) 진행중 여부
            isBackDragging: false,  // 오른쪽(이전)으로 드래그 중인지
            isLeftDragging: false,  // 왼쪽(다음)으로 드래그 중인지
            isRightMotion: false,   // 오른쪽 이동 애니메이션 상태
            isBlock: false,         // 슬라이드 전환 중(블락 처리)
            isMove: false,          // 사용자가 일정거리 이상 드래그 중임을 표시
            gestureAxis: 'none'     // 사용중인 제스처 방향('x', 'y', 'none')
        };

        var refs = [];              // 슬라이드 DOM 요소 저장
        var playlist = null;        // 슬라이드 인덱스, 이동 등 관련 메서드/상태
        var sliderWrap = null;      // trend-carousel wrapper 엘리먼트 DOM 참조

        // setTimeout에 사용되는 타이머 정보
        var timer = { value: null };
        var timer2 = { value: null };

        // 각종 이벤트 핸들러
        var eventHandlers = {
            touchMove: null,
            mouseMove: null,
            mouseUp: null
        };

        function clearAllSlideClasses() {
            var i;
            for (i = 0; i < refs.length; i++) {
                removeClasses(refs[i], SLIDE_CLASSES);
            }
        }
        
        function setSlidePosition(list) {
            var itemLength = refs.length;
            var idx;
            clearAllSlideClasses();

            for (idx = 0; idx < list.length; idx++) {
                var el = list[idx];
                if (!el.classList.contains('slideCancel')) {
                    el.style.transform = '';
                }

                // slidePos1: 현재 활성 슬라이드
                // slidePos2: 다음 슬라이드 (아이템 3개 이상일 때)
                // slidePos3: 그 다음 슬라이드 (아이템 4개 이상일 때)
                if (idx === 0) {
                    addClasses(el, ['slidePos1', 'active']);
                    state.activeEl = el;
                } else if (idx === 1 && itemLength >= 2) {
                    addClasses(el, ['slidePos2', 'active']);
                } else if (idx === 2 && itemLength >= 3) {
                    addClasses(el, ['slidePos3', 'active', 'slideTransitionNone']);
                }
            }

            state.isTransition = false;
            updateAccessibility();
        }

        // ============================================
        // 접근성
        // ============================================
        function updateAccessibility() {
            var currentSlide = playlist.current()[0];
            var i;
            for (i = 0; i < refs.length; i++) {
                var el = refs[i];
                if (!el) continue;

                var isActive = (el === currentSlide);
                el.setAttribute('aria-hidden', isActive || !config.isMobile ? 'false' : 'true');

                var link = el.querySelector('a[role="link"]');
                if (link) {
                    link.setAttribute('tabindex', isActive ? '0' : '-1');
                }
            }

            if (typeof config.onChange === 'function') {
                config.onChange(playlist.getIndex());
            }
        }

        // ============================================
        // 슬라이드 전환 함수
        // ============================================
        function moveToPrev() {
            state.isTransition = true;
            state.isRightMotion = true;

            // 현재 준비된 이전 슬라이드를 활성화 위치로 애니메이션
            if (state.activeEl) {
                state.activeEl.classList.remove('slidePos0');
                state.activeEl.classList.add('slidePos1');
                state.activeEl.style.transform = 'translateX(0px)';
                state.prevSlide.classList.add('slideIn');
            }

            safeTimeout(timer, function() {
                var list = playlist.prev();
                setSlidePosition(list);
                state.isTransition = false;
                state.isRightMotion = false;
            }, CONSTANTS.TRANSITION_DELAY);
        }

        /**
         * 다음 슬라이드로 이동 (왼쪽 드래그 시)
         * - 현재 슬라이드를 왼쪽으로 밀어내고
         * - playlist를 다음으로 변경
         */
        function moveToNext() {
            state.isTransition = true;
            var currentActive = state.activeEl;
            var outPos = config.isMobile ? -window.innerWidth : -CONSTANTS.PC_OUT;

            if (currentActive) {
                currentActive.classList.add('slideOut');
                currentActive.style.transform = 'translateX(' + outPos + 'px)';
            }

            safeTimeout(timer, function() {
                var list = playlist.next();
                setSlidePosition(list);
                if (currentActive) {
                    removeClasses(currentActive, ['slideOut', 'active']);
                    currentActive.style.transform = '';
                }
                state.isTransition = false;
            }, CONSTANTS.TRANSITION_DELAY);
        }

        /**
         * 왼쪽 드래그 애니메이션 (드래그 중)
         * - 현재 슬라이드를 왼쪽으로 이동
         */
        function slideLeftDrag() {
            if (!state.activeEl) return;
            
            var translateX = state.dragXVal;
            state.activeEl.style.transform = 'translateX(' + translateX + 'px)';
        }

        /**
         * 오른쪽 드래그 준비 (드래그 중 - 이전 슬라이드 표시)
         * - 이전 슬라이드를 화면 왼쪽에서 가져옴
         */
        function slideRightPrepare() {
            state.isRightMotion = true;
            
            var list = playlist.peekPrev();
            var prevSlide = list[0];
            
            // 이전 슬라이드 준비
            removeClasses(prevSlide, SLIDE_CLASSES);
            addClasses(prevSlide, ['slidePos0', 'active']);
            
            // 화면 왼쪽 바깥에 위치
            var startPos = config.isMobile ? -window.innerWidth : -CONSTANTS.PC_OUT;
            prevSlide.style.transform = 'translateX(' + startPos + 'px)';
            
            // activeEl을 이전 슬라이드로 변경 (드래그 추적용)
            state.prevSlide = prevSlide;
        }

        /**
         * 오른쪽 드래그 애니메이션 (드래그 중)
         * - 이전 슬라이드를 드래그에 따라 이동
         */
        function slideRightDrag() {
            if (!state.prevSlide) return;
            
            var startPos = config.isMobile ? -window.innerWidth : -CONSTANTS.PC_OUT;
            var translateX = startPos + state.dragXVal;
            state.prevSlide.style.transform = 'translateX(' + translateX + 'px)';
        }

        /**
         * 드래그 취소 시 원위치 복귀
         */
        function cancelDrag() {
            // 오른쪽 드래그 취소
            if (state.prevSlide) {
                var startPos = config.isMobile ? -window.innerWidth : -CONSTANTS.PC_OUT;
                state.prevSlide.style.transform = 'translateX(' + startPos + 'px)';
                
                safeTimeout(timer, function() {
                    if (state.prevSlide) {
                        removeClasses(state.prevSlide, ['slidePos0', 'active']);
                        state.prevSlide.style.transform = '';
                        state.prevSlide = null;
                    }
                }, CONSTANTS.TRANSITION_DELAY);
            }
            
            // 왼쪽 드래그 취소
            if (state.activeEl && !state.isBackDragging) {
                state.activeEl.style.transform = '';
            }
            
            state.isRightMotion = false;
        }

        // ============================================
        // 드래그 상태 리셋
        // ============================================
        function resetDragState() {
            state.isDragging = false;
            state.isBackDragging = false;
            state.isLeftDragging = false;
            state.dragX = 0;
            state.dragXVal = 0;
            state.startX = 0;
            state.startY = 0;
            state.prevSlide = null;
        }

        // ============================================
        // 드래그 이벤트 핸들러
        // ============================================
        var drag = {
            start: function(e) {
                // 이미 트랜지션 중이거나 블록 상태면 무시
                if (state.isBlock) {
                    return;
                }

                var point = e.touches ? e.touches[0] : e;
                
                // 마우스 이벤트의 기본 동작 방지 (드래그 선택 방지)
                if (e.type === 'mousedown' && e.cancelable) {
                    e.preventDefault();
                }

                // 상태 초기화
                state.startX = point.clientX;
                state.startY = point.clientY;
                state.dragX = 0;
                state.dragXVal = 0;
                state.gestureAxis = 'none';
                state.isDragging = true;
                state.isBackDragging = false;
                state.isMove = false;

                if (state.activeEl) {
                    state.activeEl.classList.remove('slideCancel');
                }
            },

            move: function(clientX, clientY) {
                // 드래그 중이 아니면 무시
                if (!state.isDragging) return;

                clientY = getOption(clientY, 0);
                var deltaX = clientX - state.startX;
                var deltaY = clientY - state.startY;

                // 제스처 축 결정 (처음 움직임 시)
                if (state.gestureAxis === 'none') {
                    var absX = Math.abs(deltaX);
                    var absY = Math.abs(deltaY);

                    if (absX < CONSTANTS.MIN_GESTURE && absY < CONSTANTS.MIN_GESTURE) {
                        return;
                    }

                    state.gestureAxis = (absY > absX) ? 'y' : 'x';

                    // 세로 스크롤이면 드래그 취소
                    if (state.gestureAxis === 'y') {
                        state.isDragging = false;
                        state.dragX = 0;
                        state.dragXVal = 0;
                        return;
                    }
                }

                // 세로 축이면 무시
                if (state.gestureAxis === 'y') {
                    return;
                }

                // 드래그 값 업데이트
                state.dragXVal = deltaX;
                state.dragX = deltaX;
                state.isMove = (Math.abs(deltaX) > 5);

                // 드래그 방향에 따른 처리
                if (deltaX > 0) {
                    // 오른쪽 드래그 (이전 슬라이드로)
                    if (!state.isBackDragging) {
                        state.isBackDragging = true;
                        state.isLeftDragging = false;
                        slideRightPrepare();
                    }
                    slideRightDrag();
                } else {
                    // 왼쪽 드래그 (다음 슬라이드로)
                    if (!state.isLeftDragging) {
                        state.isLeftDragging = true;
                        state.isBackDragging = false;
                    }
                    slideLeftDrag();
                }
            },

            end: function() {
                if (!state.isDragging) return;

                var dragDistance = state.dragXVal;
                
                // 드래그 거리가 임계값 초과시 슬라이드 전환
                if (Math.abs(dragDistance) > CONSTANTS.THRESHOLD) {
                    state.isBlock = true;
                    
                    if (dragDistance > 0 && state.isBackDragging) {
                        moveToPrev();
                    } else if (dragDistance < 0 && state.isLeftDragging) {
                        moveToNext();
                    }

                    safeTimeout(timer2, function() {
                        state.isBlock = false;
                    }, CONSTANTS.BLOCK_DELAY + CONSTANTS.TRANSITION_DELAY);
                } else {
                    // 임계값 미만이면 원위치로 복귀
                    cancelDrag();
                }

                resetDragState();
                state.gestureAxis = 'none';
            },
        };

        // ============================================
        // 키보드 핸들러
        // ============================================
        function handleKeydown(key) {
            if (key === 'ArrowRight') {
                var list = playlist.prev();
                var target = list[0];

                addClasses(target, ['active', 'slideTransitionNone']);
                var startPos = -CONSTANTS.OUTPOS - (config.isMobile ? window.innerWidth : CONSTANTS.PC_OUT) + 100;
                target.style.transform = 'translateX(' + startPos + 'px)';

                safeTimeout(timer2, function() {
                    addClasses(target, ['slidePos1', 'slideIn']);
                    target.classList.remove('slideTransitionNone');
                    target.style.transform = 'translateX(0px)';
                }, CONSTANTS.ARROW_DELAY);

                safeTimeout(timer, function() {
                    setSlidePosition(list);
                }, CONSTANTS.ARROW_SETTLE);
            }

            if (key === 'ArrowLeft') {
                var currentList = playlist.current();
                var currentTarget = currentList[0];

                addClasses(currentTarget, ['active', 'slideOut']);
                var outPos = config.isMobile ? -window.innerWidth : -CONSTANTS.PC_OUT;
                currentTarget.style.transform = 'translateX(' + outPos + 'px)';

                safeTimeout(timer, function() {
                    var nextList = playlist.next();
                    setSlidePosition(nextList);
                    addClasses(currentTarget, ['slideTransitionNone']);
                    currentTarget.classList.remove('active');
                }, CONSTANTS.ARROW_DELAY);
            }
        }

        function createSlideElement(content, index) {
            var slide = document.createElement('div');
            slide.setAttribute('role', 'group');
            slide.setAttribute('aria-roledescription', '슬라이드');
            slide.setAttribute('aria-label', (index + 1) + '번 슬라이드');
            slide.className = 'trend-slide';

            if (typeof content === 'string') {
                slide.innerHTML = content;
            } else if (content instanceof HTMLElement) {
                slide.appendChild(content);
            }

            return slide;
        }

        function bindLinkClickPrevention(el) {
            var link = el.querySelector('a[role="link"]');
            if (link) {
                link.addEventListener('click', function(evt) {
                    if (state.isMove) {
                        state.isMove = false;
                        if (evt.cancelable) evt.preventDefault();
                        return false;
                    }
                });
            }
        }

        /**
         * 이벤트 바인딩 (공통)
         */
        function bindEvents() {
            if (config.isDisabled || !sliderWrap) return;

            var isDesktop = !config.isMobile;
            if (!isDesktop) {
                sliderWrap.addEventListener('touchstart', drag.start, false);
                sliderWrap.addEventListener('touchend', drag.end, false);
                sliderWrap.addEventListener('mousedown', drag.start, false);

                eventHandlers.touchMove = function(e) {
                    if (state.isDragging && state.gestureAxis === 'x' && e.cancelable) {
                        e.preventDefault();
                    }
                    if (state.isDragging) {
                        drag.move(e.touches[0].clientX, e.touches[0].clientY);
                    }
                };
                sliderWrap.addEventListener('touchmove', eventHandlers.touchMove, { passive: false });

                eventHandlers.mouseMove = function(e) {
                    if (e.cancelable) e.preventDefault();
                    if (state.isDragging) drag.move(e.clientX, e.clientY);
                };
                eventHandlers.mouseUp = function() {
                    if (state.isDragging) drag.end();
                };
                window.addEventListener('mousemove', eventHandlers.mouseMove, false);
                window.addEventListener('mouseup', eventHandlers.mouseUp, false);
            }

            // 키보드 이벤트 
            sliderWrap.addEventListener('keydown', function(e) {
                handleKeydown(e.key);
            });

            // 링크 클릭 방지 (드래그 중, 모바일만 의미 있음)
            var k;
            for (k = 0; k < refs.length; k++) {
                bindLinkClickPrevention(refs[k]);
            }
        }

        /**
         * 슬라이드에 접근성 속성 추가
         */
        function setSlideAccessibility(slide, index, total) {
            slide.setAttribute('role', 'group');
            slide.setAttribute('aria-roledescription', '슬라이드');
            slide.setAttribute('aria-label', '전체 ' + total + '개 슬라이드 중 ' + (index + 1) + '번째 슬라이드');
        }

        /**
         * DOM 생성 후 마운트
         */
        function mount(rootElement) {
            if (!rootElement) return;

            // wrapper 생성
            sliderWrap = document.createElement('div');
            sliderWrap.className = 'carousel-wrapper';
            sliderWrap.tabIndex = 0;
            sliderWrap.setAttribute('role', 'region');
            sliderWrap.setAttribute('aria-label', config.ariaLabel);

            // 드래그 영역
            if (config.isMobile) {
                var dragArea = document.createElement('div');
                dragArea.className = 'dragArea';
                sliderWrap.appendChild(dragArea);
            }

            // 슬라이드 컨테이너
            var wrapArea = document.createElement('div');
            wrapArea.className = 'wrap ' + (config.isMobile ? 'mobile' : 'desktop');

            // 슬라이드 생성
            var i;
            for (i = 0; i < config.children.length; i++) {
                var slide = createSlideElement(config.children[i], i);
                setSlideAccessibility(slide, i, config.children.length);
                refs[i] = slide;
                wrapArea.appendChild(slide);
            }
            sliderWrap.appendChild(wrapArea);

            // 외부 컨테이너
            var outer = document.createElement('div');
            var containerClass = 'container';
            if (!config.isMobile) containerClass += ' desktop';
            if (config.isDisabled) containerClass += ' disabled';
            outer.className = containerClass;
            outer.appendChild(sliderWrap);
            rootElement.appendChild(outer);

            // 이벤트 바인딩 및 초기화
            bindEvents();
            playlist = createLoopedPlaylist(refs, refs.length);
            setSlidePosition(playlist.current());
        }

        /**
         * 기존 DOM에 바인딩
         */
        function bindExisting(rootElement) {
            if (!rootElement) return;

            // 컨테이너 클래스 설정
            var container = rootElement.querySelector('.container');
            if (container) {
                container.classList.remove('desktop', 'disabled');
                if (!config.isMobile) container.classList.add('desktop');
                if (config.isDisabled) container.classList.add('disabled');
            }

            sliderWrap = rootElement.querySelector('.wrapper') || rootElement.querySelector('.lt-swiper .wrapper') || rootElement;

            var wrapArea = rootElement.querySelector('.wrap');
            if (!wrapArea) return;
            wrapArea.classList.remove('mobile', 'desktop');
            wrapArea.classList.add(config.isMobile ? 'mobile' : 'desktop');

            // 슬라이드 찾기
            var existingSlides = wrapArea.querySelectorAll('.trend-slide');
            if (existingSlides.length === 0) return;

            var i;
            for (i = 0; i < existingSlides.length; i++) {
                refs[i] = existingSlides[i];
                setSlideAccessibility(refs[i], i, existingSlides.length);
            }

            sliderWrap.tabIndex = 0;
            sliderWrap.setAttribute('role', 'region');
            sliderWrap.setAttribute('aria-label', config.ariaLabel);

            bindEvents();
            playlist = createLoopedPlaylist(refs, refs.length);
            setSlidePosition(playlist.current());
        }

        function destroy() {
            if (timer.value) clearTimeout(timer.value);
            if (timer2.value) clearTimeout(timer2.value);

            if (eventHandlers.mouseMove) {
                window.removeEventListener('mousemove', eventHandlers.mouseMove);
            }
            if (eventHandlers.mouseUp) {
                window.removeEventListener('mouseup', eventHandlers.mouseUp);
            }
        }

        return {
            mount: mount,
            bindExisting: bindExisting,
            destroy: destroy,
            getIndex: function() {
                return playlist ? playlist.getIndex() : 0;
            }
        };
    }

    global.CarouselPosting = CarouselPosting;
})(window);

/**
 * TrendIndicator - 인디케이터 컴포넌트
 */
(function() {
    var config = {
        $root: null,
        $current: null,
        $total: null,
        current: 1,
        total: 4
    };

    function updateDisplay() {
        if (config.$current) config.$current.innerText = config.current;
        if (config.$total) config.$total.innerText = config.total;
    }

    function init() {
        config.$root = document.getElementById('trend-indicator');
        if (config.$root) {
            config.$current = config.$root.querySelector('.current');
            config.$total = config.$root.querySelector('.total');
        }
        updateDisplay();
    }

    window.TrendIndicator = {
        init: function() {
            if (window.innerWidth < 768) {
                init();
            }
        },
        setCurrent: function(current) {
            config.current = current;
            updateDisplay();
        },
        setTotal: function(total) {
            config.total = total;
            updateDisplay();
        },
        set: function(obj) {
            if (obj.current !== undefined) config.current = obj.current;
            if (obj.total !== undefined) config.total = obj.total;
            updateDisplay();
        }
    };

    // DOM 준비 시 초기화
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

document.addEventListener('DOMContentLoaded', function() {
    var trendCarouselEl = document.getElementById('trend-carousel');
    if (!trendCarouselEl || typeof window.CarouselPosting !== 'function') return;

    var MOBILE_BREAKPOINT = 768;
    var RESIZE_DEBOUNCE_DELAY = 200;
    
    var resizeTimer = null;
    var currentIsMobile = window.innerWidth < MOBILE_BREAKPOINT;
    var carouselInstance = null;

    function getIsMobile() {
        return window.innerWidth < MOBILE_BREAKPOINT;
    }

    function getSlideCount() {
        var wrapArea = trendCarouselEl.querySelector('.wrap');
        return wrapArea ? wrapArea.querySelectorAll('.trend-slide').length : 0;
    }

    function initCarousel(isMobile) {
        // 기존 인스턴스 정리
        if (carouselInstance) {
            carouselInstance.destroy();
        }

        carouselInstance = window.CarouselPosting({
            ariaLabel: '리빙 트렌드 이미지 슬라이드',
            isMobile: isMobile,
            changeCarousel: function(index) {
                if (window.TrendIndicator) {
                    window.TrendIndicator.setCurrent(index + 1);
                }
            }
        });

        carouselInstance.bindExisting(trendCarouselEl);
        window.trendCarouselInstance = carouselInstance;
    }

    function handleResize() {
        var newIsMobile = getIsMobile();
        
        // isMobile 상태가 변경된 경우에만 재초기화
        if (newIsMobile !== currentIsMobile) {
            currentIsMobile = newIsMobile;
            initCarousel(currentIsMobile);
        }
    }

    function debouncedResize() {
        if (resizeTimer) {
            clearTimeout(resizeTimer);
        }
        resizeTimer = setTimeout(handleResize, RESIZE_DEBOUNCE_DELAY);
    }

    // 초기화
    initCarousel(currentIsMobile);

    var slideCount = getSlideCount();
    if (window.TrendIndicator && slideCount > 0) {
        window.TrendIndicator.setTotal(slideCount);
        window.TrendIndicator.setCurrent(1);
    }

    // 리사이즈 이벤트 바인딩
    window.addEventListener('resize', function() {
        debouncedResize();
    });

    // DOM 생성 후 carousel 초기화
    window.initTrendCarousel = function() {
        var slideCount = getSlideCount();
        if (slideCount > 0) {
            initCarousel(getIsMobile());
            if (window.TrendIndicator) {
                window.TrendIndicator.setTotal(slideCount);
                window.TrendIndicator.setCurrent(1);
            }
        }
    };
});
